// extracted by mini-css-extract-plugin
module.exports = {"container":"Order_container__3rhwU"};